import classNames from 'classnames'
import { Children } from 'react'

import { IconCheck } from '../Icons'

type Props = {
  list: string[]
  currentStep: number
  childrenAfterStep?: number
  size?: 'md' | 'lg'
  fullWidth?: boolean
  spaceless?: boolean
  showLines?: boolean
}

const Stepper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  currentStep = 2,
  list,
  childrenAfterStep,
  size = 'md',
  fullWidth,
  spaceless,
  showLines,
}) => {
  return (
    <>
      <div
        className={classNames('flex w-full space-x-2 text-center md:space-x-8', {
          'py-4': !spaceless,
        })}
      >
        {list.map((item, index) => {
          const isCurrent = currentStep === index + 1

          return (
            <div
              key={item}
              className={classNames(
                'flex items-center space-x-2 font-medium',
                isCurrent ? 'text-purple-base' : 'text-grey-base',
                {
                  'w-full': fullWidth,
                },
              )}
            >
              {currentStep <= index + 1 ? (
                <div
                  className={classNames(
                    'flex items-center justify-center rounded-full',
                    isCurrent ? 'bg-purple-base text-white' : 'bg-grey-extra-light text-grey-base',
                    {
                      'h-7 w-7': size === 'md',
                      'h-12 w-12': size === 'lg',
                    },
                  )}
                >
                  <div
                    className={classNames('leading-7', {
                      'text-sm-none': size === 'md',
                      'text-lg-none': size === 'lg',
                    })}
                  >
                    {index + 1}
                  </div>
                </div>
              ) : (
                <div
                  className={classNames('flex items-center justify-center rounded-full bg-grey-base text-white', {
                    'h-7 w-7': size === 'md',
                    'h-12 w-12': size === 'lg',
                  })}
                >
                  <IconCheck className={classNames({ 'icon-sm': size === 'md', 'icon-md': size === 'lg' })} />
                </div>
              )}

              <div
                className={classNames('font-sans capsize', {
                  'text-base-none': size === 'md',
                  'text-lg-none': size === 'lg',
                })}
              >
                {item}
              </div>
              {showLines && index < list.length - 1 ? (
                <div className="grow pl-6">
                  <div
                    className={classNames(
                      'border-t',
                      index + 1 === currentStep ? 'border-purple-base' : 'border-grey-light',
                    )}
                  ></div>
                </div>
              ) : null}

              {childrenAfterStep === index + 1 ? <div className="inline-block">{children}</div> : null}
            </div>
          )
        })}
      </div>

      {childrenAfterStep ? null : (
        <div>{Children.map(children, (child, index) => (index + 1 === currentStep ? <div>{child}</div> : null))}</div>
      )}
    </>
  )
}

export default Stepper
